module.exports = __webpack_public_path__ + "static/goalkeeper-7601509c6f09d7df1ed32f773ff7c342.svg";